// =============================================================================
// Fase 5.5 — Step 1: Soggetto della richiesta (dipendente vs familiare)
// =============================================================================
import React from "react";
import { User, Users } from "lucide-react";

export function Step1SoggettoRichiesta({ state, setField }) {
  const opts = [
    {
      key: "dipendente",
      icon: User,
      title: "Dipendente convenzionato",
      desc: "Sono io il dipendente/collaboratore dell'azienda convenzionata.",
    },
    {
      key: "familiare",
      icon: Users,
      title: "Appartenente allo stato di famiglia del dipendente",
      desc: "Sono un familiare convivente del dipendente (coniuge, figlio, genitore…).",
    },
  ];
  return (
    <div className="space-y-4" data-testid="rca-step1">
      <div>
        <h2 className="text-lg sm:text-xl font-semibold text-[#0F1F14]">
          Il preventivo è per il dipendente convenzionato o per un appartenente
          al suo stato di famiglia?
        </h2>
        <p className="text-sm text-[#4A5E51] mt-1">
          Seleziona chi sarà il contraente principale della polizza.
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {opts.map((o) => {
          const on = state.soggetto_richiesta === o.key;
          const Icon = o.icon;
          return (
            <button
              key={o.key}
              type="button"
              onClick={() => setField("soggetto_richiesta", o.key)}
              data-testid={`rca-soggetto-${o.key}`}
              className={`text-left rounded-2xl border-2 p-5 transition-all ${
                on
                  ? "border-[var(--brand-accent,#163321)] bg-[#163321]/5 ring-2 ring-[var(--brand-accent,#163321)]/20"
                  : "border-[#E5E2DB] bg-white hover:border-[#4A5E51]"
              }`}
            >
              <Icon className="w-6 h-6 text-[var(--brand-accent,#163321)] mb-2" />
              <div className="text-sm font-semibold text-[#0F1F14]">{o.title}</div>
              <div className="text-[12px] text-[#4A5E51] mt-1 leading-snug">{o.desc}</div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
